import React, { useState } from 'react';
import { Layout, Menu, Button, Dropdown, Drawer, Grid, Space } from 'antd';
import { Link, useLocation, useNavigate, Outlet } from 'react-router-dom';
import {
  FileTextOutlined,
  WalletOutlined,
  NotificationOutlined,
  KeyOutlined,
  MenuOutlined,
  BellOutlined,
  DownOutlined,
  LogoutOutlined,
  HistoryOutlined,
} from '@ant-design/icons';
import Brand from './Brand';
import SupportButton from './SupportButton';
import { useOrderImport } from '../contexts/OrderImportContext';
import AnnouncementBanner from './AnnouncementBanner';
import { useAuth } from '../contexts/AuthContext';
import { canManageWorkspace } from '../utils/workspaceAccess';

const workItems = [
  { key: '/app/orders', icon: <FileTextOutlined />, label: '订单管理' },
  { key: '/app/points', icon: <WalletOutlined />, label: '账户积分' },
];
const adminItems = [
  {
    key: '/app/announcements',
    icon: <NotificationOutlined />,
    label: '公告管理',
  },
  { key: '/app/invitation-codes', icon: <KeyOutlined />, label: '邀请码管理' },
  { key: '/app/history', icon: <HistoryOutlined />, label: '开发变更记录' },
];
const MainLayout = () => {
  const { user, logout } = useAuth();
  const { uploading } = useOrderImport();
  const navigate = useNavigate();
  const location = useLocation();
  const screens = Grid.useBreakpoint();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const active = [...workItems, ...adminItems].find((item) =>
    location.pathname.startsWith(item.key),
  );
  const go = ({ key }) => {
    navigate(key);
    setMobileOpen(false);
  };
  const handleLogout = async () => {
    setLoggingOut(true);
    await logout();
    navigate('/login', { replace: true });
  };
  const navigation = (
    <div className="sidebar-inner">
      <Brand />
      <div className="sidebar-caption">采购业务</div>
      <Menu
        mode="inline"
        selectedKeys={[active?.key]}
        items={workItems}
        onClick={go}
      />
      {canManageWorkspace(user) && (
        <>
          <div className="sidebar-caption">内部管理</div>
          <Menu
            mode="inline"
            selectedKeys={[active?.key]}
            items={adminItems}
            onClick={go}
          />
        </>
      )}
      <div className="sidebar-bottom">
        <Link to="/home">产品首页</Link>
        <span className="sidebar-edition">Amazon 采购协作</span>
      </div>
    </div>
  );
  return (
    <Layout className="workspace">
      <a className="skip-link" href="#workspace-content">
        跳转到工作区
      </a>
      {screens.md && (
        <Layout.Sider width={208} className="workspace-sidebar">
          {navigation}
        </Layout.Sider>
      )}
      <Drawer
        title="工作空间"
        placement="left"
        width={240}
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        styles={{ body: { padding: 0 } }}
      >
        {navigation}
      </Drawer>
      <Layout className="workspace-main">
        <header className="workspace-header">
          <div className="workspace-breadcrumb">
            采购工作区<span>/　{active?.label || '工作台'}</span>
          </div>
          <div className="workspace-mobile-brand">
            <Button
              type="text"
              icon={<MenuOutlined />}
              aria-label="打开导航"
              onClick={() => setMobileOpen(true)}
            />
            <Brand compact />
          </div>
          <Space size={8}>
            <SupportButton>{screens.md ? '客服' : null}</SupportButton>
            <Button
              type="text"
              icon={<BellOutlined />}
              aria-label="查看最近公告"
              onClick={() => setNotificationsOpen(true)}
            />
            <Dropdown
              menu={{
                items: [
                  {
                    key: 'logout',
                    disabled: uploading,
                    icon: <LogoutOutlined />,
                    label: uploading ? '订单导入中，请稍候退出' : '退出登录',
                  },
                ],
                onClick: handleLogout,
              }}
              trigger={['click']}
            >
              <Button
                type="text"
                className="account-button"
                loading={loggingOut}
              >
                <span className="account-monogram" aria-hidden="true">
                  {user?.username?.slice(0, 1).toUpperCase()}
                </span>
                <span className="account-name">{user?.username}</span> <DownOutlined />
              </Button>
            </Dropdown>
          </Space>
        </header>
        <main className="workspace-content" id="workspace-content">
          <AnnouncementBanner
            open={notificationsOpen}
            onClose={() => setNotificationsOpen(false)}
            onOpen={() => setNotificationsOpen(true)}
          />
          <Outlet />
        </main>
      </Layout>
    </Layout>
  );
};
export default MainLayout;
